import { motion } from "motion/react";

interface LoadingSignalProps {
  message?: string;
}

// Loading state showing the classic 22娘 running animation
// (the iconic bilibili loading GIF, bundled locally as /loading-2233.gif).
// The GIF speaks for itself — minimal surrounding chrome.

export default function LoadingSignal({
  message = "SEARCHING SIGNAL",
}: LoadingSignalProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 bg-void z-40">
      <motion.div
        animate={{ y: [0, -6, 0] }}
        transition={{
          duration: 1.0,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="relative"
      >
        {/* 22娘跑步加载动画 */}
        <img
          src="/loading-2233.gif"
          alt="加载中"
          width={196}
          height={156}
          className="block"
        />
        {/* 微弱 CRT 荧光 */}
        <div
          className="absolute inset-0 pointer-events-none mix-blend-screen"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, rgba(255,87,34,0.15) 0%, transparent 70%)",
          }}
        />
      </motion.div>

      <div className="flex items-center gap-1">
        <span className="vfd text-sm sm:text-base tracking-widest2">
          {message}
        </span>
        <motion.span
          className="vfd text-sm sm:text-base"
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1.0, repeat: Infinity }}
        >
          ...
        </motion.span>
      </div>

      {/* Cute loading dots in 22/33 colors */}
      <div className="flex gap-2">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="block w-2 h-2 rounded-full"
            style={{
              background:
                i === 0 ? "#73B3D8" : i === 1 ? "#FF5722" : "#F5A3C8",
            }}
            animate={{ opacity: [0.3, 1, 0.3], scale: [0.8, 1.2, 0.8] }}
            transition={{
              duration: 1.0,
              repeat: Infinity,
              delay: i * 0.18,
            }}
          />
        ))}
      </div>
    </div>
  );
}